import { useTranslation } from 'react-i18next';
import type { UnitAvailability } from '@hp/domain';

/** Translated label of a unit availability (`projects:availability.*`, capitalised for badges and selects). */
export function useAvailabilityLabel(): (availability: UnitAvailability) => string {
  const { t } = useTranslation('projects');
  return (availability) => t(`availability.${availability}`);
}
